import React, { Component } from 'react'
import { observer } from 'mobx-react'

import SystemUptimeStore from './SystemUptimeStore'
import Panel from '../../../../UniformComponents/Panel'
import ExploriDatePicker from '../../../ExploriDatePicker'
import DataTable from '../../../DataTable'
import Loader from '../Loader'

import './systemUptime.scss'

@observer
class SystemUptime extends Component {
    constructor(props) {
        super(props)
        this.store = props.store
        this.systemUptimeStore = new SystemUptimeStore(this.store)
    }

    componentDidMount() {
        this.store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'uptime',
                url: '/intranet/uptime',
                title: 'System Uptime',
            },
        ]
    }

    renderFilterPanel = () => {
        const { handleChangeRequest, getFormatedDates, request } = this.systemUptimeStore
        return (
            <Panel cssClass="filter-panel">
                <div>
                    <ExploriDatePicker
                        onChange={(e) => handleChangeRequest(e, 'start')}
                        timeFormat="hh:mm"
                        dateTimeFormat="yyyy-MM-DD hh:mm A"
                        placeholder={getFormatedDates(request.startTime)}
                    />
                </div>
                <div>
                    <ExploriDatePicker
                        onChange={(e) => handleChangeRequest(e, 'end')}
                        timeFormat="hh:mm"
                        dateTimeFormat="yyyy-MM-DD hh:mm A"
                        placeholder={getFormatedDates(request.endTime)}
                    />
                </div>
            </Panel>
        )
    }

    renderResultPanel = () => {
        const {
            tabels, upTime, columns, isResultFetched, getOverallUptime,
        } = this.systemUptimeStore
        return (
            <Panel cssClass="result-panel">
                {tabels.map((element) => (
                    <div>
                        <div>
                            <h3>
                                {element.name}
                                {isResultFetched ? (
                                    <div>
                                        {`${getOverallUptime(upTime[element.value])} `}
                                        {' '}
                                        %
                                    </div>
                                ) : null}
                            </h3>
                        </div>

                        <DataTable
                            store={{ filteredList: upTime[element.value] }}
                            dataSet={upTime[element.value]}
                            columns={columns}
                        />
                    </div>
                ))}
            </Panel>

        )
    }

    render() {
        const { isResultFetched } = this.systemUptimeStore
        return (
            <div id="systemUptime">
                {!isResultFetched ? <Loader show /> : null}
                <div style={{ display: 'flex', gap: 20 }}>
                    <div style={{ width: '25%' }}>
                        {this.renderFilterPanel()}
                    </div>
                    <div style={{ width: '75%' }}>
                        {this.renderResultPanel()}
                    </div>
                </div>
            </div>
        )
    }
}
export default SystemUptime
